/* eslint-disable */

import { i18n } from '@/locales/i18n';
import IdField from '@/shared/fields/id-field';
import StringField from '@/shared/fields/string-field';
import StringArrayField from '@/shared/fields/string-array-field';
import BooleanField from '@/shared/fields/boolean-field';
import DateTimeField from '@/shared/fields/date-time-field';
import EnumeratorField from '@/shared/fields/enumerator-field';
import IntegerField from '@/shared/fields/integer-field';
import DecimalField from '@/shared/fields/decimal-field';
import JsonField from '@/shared/fields/json-field';
// import ImagesField from '@/shared/fields/images-field';
// import DateTimeRangeField from '@/shared/fields/date-time-range-field';
// import GenericField from '@/shared/fields/generic-field';
import { GenericModel } from '@/shared/model/generic-model';

function label(name) {
  return i18n(`notification.fields.${name}`);
}
function enumeratorLabel(name, value) {
  return i18n(`notification.enumerators.${name}.${value}`);
}

const fields = {
  id: new IdField('id', label('id'), { required: true }),
  title: new JsonField('title', label('title'), ['en', 'ar']),
  body: new JsonField('body', label('body'), ['en', 'ar']),
  data: new JsonField('data', label('data'), ['key', 'value']),
  image: new StringField('image', label('image'), { required: true }),
  action: new StringField('action', label('action')),
  isRead: new BooleanField('isRead', label('isRead')),
  isRemoved: new BooleanField('isRemoved', label('isRemoved')),
  userType: new StringField('userType', label('userType')),
  // action: new EnumeratorField('sellingType', label('sellingType'), [
  //   { id: 'normal', label: enumeratorLabel('sellingType', 'normal') },
  //   { id: 'auction', label: enumeratorLabel('sellingType', 'auction') }
  // ], { required: true }),
  
  createdAt: new DateTimeField('createdAt', label('createdAt')),
  updatedAt: new DateTimeField('updatedAt', label('updatedAt')),
  createdBy: new StringField('createdBy', label('createdBy')),
  updatedBy: new StringField('updatedBy', label('updatedBy')),
  // createdAtRange: new DateTimeRangeField('createdAtRange', label('createdAtRange')),
};

export class NotificationModel extends GenericModel {
  static get fields() {
    return fields;
  }
}
